import { icon } from '@fortawesome/fontawesome-svg-core'
import { faHeart } from '@fortawesome/free-solid-svg-icons'

const supported = typeof Element.prototype.animate == 'function'
&& CSS.supports('translate', '1px 1px 0px')
&& CSS.supports('scale', '1.5')
&& CSS.supports('inset', '0 0 0 0')
&& !matchMedia('(prefers-reduced-motion: reduce)').matches

const styles = { stroke: '#fff', 'stroke-width': '20' }
const heartIcon = icon(faHeart, { styles }).html[0]
let container

const createHeart = (x, color) => {
  const phase = Math.random() * 360
  const radius = Math.random() * 1
  const speed = 1 + Math.random() * 2

  if (!container) {
    container = document.createElement('div')
    container.style.pointerEvents = 'none'
    container.style.position = 'fixed'
    container.style.inset = '0 0 0 0'
    container.style.overflow = 'hidden'
    container.style.zIndex = 1
    document.body.appendChild(container)
  }

  const heart = document.createElement('div')
  heart.style.position = 'absolute'
  heart.style.top = 0
  heart.style.left = x + 'px'
  heart.style.color = color
  heart.style.scale = 1.5
  heart.style.opacity = 1
  heart.style.translate = '0px -150px 0px'
  heart.style.transition = [
    `translate ${(innerHeight + 200) / (speed * 120)}s linear`,
    `opacity ${innerHeight / 60}s`,
  ].join()

  heart.innerHTML = heartIcon
  container.appendChild(heart)

  heart.addEventListener('transitionend', e => {
    if (e.propertyName == 'translate')
      container.removeChild(heart)
  })

  heart.offsetHeight // force draw
  heart.style.translate = `0px ${innerHeight + 50}px 0px`
  heart.style.opacity = 0

  heart.animate?.([
    { transform: `translateX(-${radius * 30}px) rotate(${radius * 15}deg)` },
    { transform: `translateX(${radius * 30}px) rotate(-${radius * 15}deg)` },
  ], {
    duration: 1000,
    iterations: Infinity,
    delay: phase,
    direction: 'alternate',
    easing: 'ease-in-out',
  })
}

export const rainHearts = ({ density, color }) => {
  if (!supported) return
  density = density / 16
  const count = innerWidth * density
  for (let i = 0; i < count; i++) {
    createHeart(i / density, color)
  }
}
